import CurrencyFormatter from "currency-formatter";

export default {
  formatMoney(amount, currency) {
    let maximumFractionDigits = 8;
    const absAmount = Math.abs(amount);
    if (absAmount === 0) {
      maximumFractionDigits = 0;
    } else if (currency === "BTC") {
      maximumFractionDigits =
        window.innerWidth >= 375 || absAmount <= 0.000001 ? 8 : 7;
    } else if (absAmount >= 1) {
      maximumFractionDigits = 2;
    } else if (absAmount >= 0.01) {
      maximumFractionDigits = 3;
    } else if (absAmount >= 0.001) {
      maximumFractionDigits = 4;
    } else if (absAmount >= 0.0001) {
      maximumFractionDigits = 5;
    } else if (absAmount >= 0.00001) {
      maximumFractionDigits = 6;
    } else if (absAmount >= 0.000001) {
      maximumFractionDigits = 7;
    }

    if (this.currency === "ETH") {
      return CurrencyFormatter.format(amount, {
        symbol: "?",
        decimal: ".",
        thousand: ",",
        precision: maximumFractionDigits,
        format: "%v%s",
      });
    } else {
      return CurrencyFormatter.format(amount, {
        code: currency,
        precision: maximumFractionDigits,
      });
    }
  },
};
